import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Typography, Alert } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createFolder } from '../../redux/slices/folderSlice';
import { toast } from 'react-toastify';

const CreateFolder = ({ open, onClose }) => {
  const [folderName, setFolderName] = useState('');
  const dispatch = useDispatch();
  
  // Karakter sınırı
  const MAX_FOLDER_NAME_LENGTH = 50; // Klasör adı için maksimum karakter sayısı

  const handleCreateFolder = () => {
    if (!folderName.trim()) {
      toast.warning("Lütfen klasör adını girin");
      return;
    }
    
    // Karakter sınırı kontrolü
    if (folderName.trim().length > MAX_FOLDER_NAME_LENGTH) {
      toast.error(`Klasör adı en fazla ${MAX_FOLDER_NAME_LENGTH} karakter olabilir. Şu anda ${folderName.trim().length} karakter girdiniz.`);
      return;
    }
    
    // Minimum karakter kontrolü
    if (folderName.trim().length < 2) {
      toast.warning("Klasör adı en az 2 karakter olmalıdır");
      return;
    }
    
    // Özel karakter kontrolü
    const invalidChars = /[<>:"/\\|?*]/g;
    if (invalidChars.test(folderName)) {
      toast.error("Klasör adında şu karakterler kullanılamaz: < > : \" / \\ | ? *");
      return;
    }
    
    dispatch(createFolder(folderName.trim()));
    toast.success("Klasör başarıyla oluşturuldu");
    setFolderName('');
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ 
        p: 4, 
        bgcolor: 'background.paper', 
        margin: 'auto', 
        mt: '20%', 
        width: 400,
        borderRadius: 2,
        boxShadow: 24
      }}>
        <Typography variant="h6" mb={2}>Klasör Oluştur</Typography>
        
        {/* Karakter sınırı bilgi mesajı */}
        <Alert 
          severity="info" 
          sx={{ mb: 2, fontSize: '0.875rem' }}
        >
          Klasör adı en az 2, en fazla {MAX_FOLDER_NAME_LENGTH} karakter olabilir
        </Alert>
        
        <TextField
          label="Klasör Adı"
          variant="outlined"
          fullWidth
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
          sx={{ mb: 2 }}
          inputProps={{ 
            maxLength: MAX_FOLDER_NAME_LENGTH + 10 // Input'ta biraz daha fazla yazabilsin ama kontrol edip uyaralım
          }}
          helperText={`${folderName.length}/${MAX_FOLDER_NAME_LENGTH} karakter`}
          error={folderName.length > MAX_FOLDER_NAME_LENGTH}
        />
        
        {/* Karakter sınırı aşıldığında uyarı */}
        {folderName.length > MAX_FOLDER_NAME_LENGTH && (
          <Alert 
            severity="error" 
            sx={{ mb: 2, fontSize: '0.875rem' }}
          >
            Karakter sınırı aşıldı! Lütfen klasör adını kısaltın.
          </Alert>
        )}
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button 
            variant="outlined" 
            fullWidth 
            onClick={onClose}
          >
            İptal
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            fullWidth 
            onClick={handleCreateFolder}
            disabled={!folderName.trim() || folderName.length > MAX_FOLDER_NAME_LENGTH}
          >
            Oluştur
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
export default CreateFolder;